import React from 'react';
import { Skeleton } from '@mui/material';

export const TileSkeleton = () => {
    return <Skeleton variant="rectangular" height={508} />;
};
